import { createContext, useContext } from 'react'
import { type Entitlement } from '@terros/common'
import { type QueryResponseWithoutData } from '../hooks'

export type EntitlementContextType = QueryResponseWithoutData & {
  entitlements: Entitlement[]
  entitlementSet: Set<Entitlement>
  hasEntitlement: (entitlement: Entitlement) => boolean
  trialEntitlements: Entitlement[]
  purchasedEntitlements: Entitlement[]
}

export const EntitlementContext = createContext<EntitlementContextType | undefined>(undefined)

export const useEntitlementContext = (): EntitlementContextType => {
  const context = useContext(EntitlementContext)
  if (!context) throw new Error('useEntitlementContext must be used within an EntitlementContext.Provider')
  return context
}

export const useLoadedEntitlement = (entitlement: Entitlement): boolean => {
  const { entitlementSet } = useEntitlementContext()
  return entitlementSet.has(entitlement)
}
